<template>
    <div>
        <img class="pa-mx-auto pa-my-0" src="../../../assets/images/compare-loading.png" alt="">
        <div class="pa-mt-2 pa-flex pa-items-center pa-justify-center">
            <PtIcon icon="SolidLoadingBars" />
            <span class="pa-ml-2 pa-text-gray-450">{{ t('patent-view.compareView.lookingForSimilarities') }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import { useI18n } from '@/composables/use-i18n';

const { t } = useI18n();

</script>


<style lang="scss">

</style>
